
interface HeaderProps {
  onLoginClick?: () => void;
}

export default function Header({ onLoginClick }: HeaderProps) {
  return (
    <header className="bg-white shadow-sm border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <a href="https://ibxshipping.com/" target="_blank" rel="noopener noreferrer">
                <img 
                  src="https://static.readdy.ai/image/5a77eaf9b7ee768325ad53b880dc4b0d/173baa716225a08bb8a69cc3a9aae0e1.png"
                  alt="IBX Shipping"
                  className="h-16 w-auto cursor-pointer"
                />
              </a>
            </div>
          </div>
          
          <nav className="hidden md:flex space-x-8">
            {/* Navigation items removed */}
          </nav>

          <div className="md:hidden">
            <button className="text-gray-700 hover:text-blue-600">
              <i className="ri-menu-line text-xl"></i>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}
